import { AppActionTypes } from 'context/actions';
import { DispatchType } from 'context';

export const appReducer = (state: any, { type, payload }: DispatchType) => {
  switch (type) {
    case AppActionTypes.SET_LOADING: {
      return {
        ...state,
        loading: payload,
      };
    }
    case AppActionTypes.SET_ERROR: {
      return {
        ...state,
        error: payload,
      };
    }
    case AppActionTypes.SET_INITIAL_DATA: {
      return {
        ...state,
        creative: payload,
      };
    }
    case AppActionTypes.SET_PLAYER_VIEW: {
      return {
        ...state,
        ...payload,
      };
    }
    case AppActionTypes.SET_SUPERFRAME_LOADED: {
      return {
        ...state,
        superFrameLoaded: payload
      }
    }

    case AppActionTypes.SET_SCREEN_SIZE_CLASS: {
      return {
        ...state,
        screenSizeClass: payload
      }
    }

    case AppActionTypes.SET_BANNER_ACTIVE: {
      return {
        ...state,
        displayBanner: { ...state.displayBanner, ...payload }
      }
    }

    case AppActionTypes.SET_MAIN_CONTENT_REF: {
      return {
        ...state,
        mainContent: payload
      }
    }
    
    case AppActionTypes.SET_PLAYER_SIZE_FORMAT: {
      return {
        ...state,
        playerSizeFormat: payload,
      };
    }

    case AppActionTypes.SET_PARAMS: {
      return {
        ...state,
        ...payload,
      };
    }

    case AppActionTypes.SET_GALLERY_PARAMS: {
      return {
        ...state,
        galleryParams: payload,
      };
    }

    case AppActionTypes.SET_ACTIVE_CREATIVE_VIEW: {
      return {
        ...state,
        activeCreativeView: {...state.activeCreativeView, ...payload},
      };
    }

    case AppActionTypes.SET_SIZE_CHANGER_LIST: {
      return {
        ...state,
        sizeViewList: payload,
      };
    }

    case AppActionTypes.SET_SHOW_BANNER_OPTIONS: {
      return {
        ...state,
        showBannerOptions: payload,
      }
    }

    default:
      console.log(`Unhandled action type: ${type}`);
      return state;
  }
};
